/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import {
  Email,
  isEmail,
  ScreenName,
  isScreenName,
  UnencryptedPassword,
  isUnencryptedPassword,
  UserId,
  isUserId,
} from "../core/types.generated";
import {
  RoleV1,
  isRoleV1,
  RoleV2,
  isRoleV2,
} from "../permission/types.generated";
import { Tagged, bridgesIsTaggedHack as isTagged } from "@cartographerio/util";

export type AccessToken = Tagged<"AccessToken">;

export interface Identity<R> {
  userId: UserId;
  firstName: string;
  lastName: string;
  screenName: ScreenName;
  email: Email;
  roles: R[];
}

export type IdentityV1 = Identity<RoleV1>;

export type IdentityV2 = Identity<RoleV2>;

export interface Credentials<R> {
  token: AccessToken;
  identity: Identity<R>;
}

export type CredentialsV1 = Credentials<RoleV1>;

export type CredentialsV2 = Credentials<RoleV2>;

export interface TermsDocument {
  title: string;
  url: string;
  description: string;
}

export interface AccountNotFound {
  email: Email;
}

export interface InvalidEmail {
  email: string;
}

export interface LoginRequired {}

export interface PasswordIncorrect {
  email: Email;
}

export interface PasswordRequired {
  email: Email;
}

export interface TermsNotAccepted {
  email: Email;
  version: number;
  documents: TermsDocument[];
}

export type LoginChallenge =
  | ({ type: "AccountNotFound" } & AccountNotFound)
  | ({ type: "InvalidEmail" } & InvalidEmail)
  | ({ type: "LoginRequired" } & LoginRequired)
  | ({ type: "PasswordIncorrect" } & PasswordIncorrect)
  | ({ type: "PasswordRequired" } & PasswordRequired)
  | ({ type: "TermsNotAccepted" } & TermsNotAccepted);

export interface LoginRequest {
  email: string;
  password?: UnencryptedPassword | null;
  loginAs?: Email | null;
  acceptTerms?: boolean | null;
}

export type LoginResponse<R> =
  | ({ type: "Credentials" } & Credentials<R>)
  | LoginChallenge;

export type LoginResponseV1 = LoginResponse<RoleV1>;

export type LoginResponseV2 = LoginResponse<RoleV2>;

export type ResetPasswordToken = Tagged<"ResetPasswordToken">;

export interface ForgotPasswordRequest {
  email: Email;
}

export interface ResetPasswordRequest {
  token: ResetPasswordToken;
  password: UnencryptedPassword;
}

export type CheckResetPasswordTokenResult = "expired" | "invalid" | "valid";

export interface CheckResetPasswordTokenResponse {
  token: ResetPasswordToken;
  result: CheckResetPasswordTokenResult;
}

export const isAccessToken = (v: any): v is AccessToken => {
  return isTagged((a0: any): a0 is "AccessToken" => a0 === "AccessToken")(v);
};

export const isIdentity =
  <R>(isR: (r: any) => r is R) =>
  (v: any): v is Identity<R> => {
    return (
      typeof v === "object" &&
      v != null &&
      "userId" in v &&
      isUserId(v.userId) &&
      "firstName" in v &&
      typeof v.firstName === "string" &&
      "lastName" in v &&
      typeof v.lastName === "string" &&
      "screenName" in v &&
      isScreenName(v.screenName) &&
      "email" in v &&
      isEmail(v.email) &&
      "roles" in v &&
      Array.isArray(v.roles) &&
      v.roles.every((i: any) => isR(i))
    );
  };

export const isIdentityV1 = (v: any): v is IdentityV1 => {
  return isIdentity((a0: any): a0 is RoleV1 => isRoleV1(a0))(v);
};

export const isIdentityV2 = (v: any): v is IdentityV2 => {
  return isIdentity((a0: any): a0 is RoleV2 => isRoleV2(a0))(v);
};

export const isCredentials =
  <R>(isR: (r: any) => r is R) =>
  (v: any): v is Credentials<R> => {
    return (
      typeof v === "object" &&
      v != null &&
      "token" in v &&
      isAccessToken(v.token) &&
      "identity" in v &&
      isIdentity((a0: any): a0 is R => isR(a0))(v.identity)
    );
  };

export const isCredentialsV1 = (v: any): v is CredentialsV1 => {
  return isCredentials((a0: any): a0 is RoleV1 => isRoleV1(a0))(v);
};

export const isCredentialsV2 = (v: any): v is CredentialsV2 => {
  return isCredentials((a0: any): a0 is RoleV2 => isRoleV2(a0))(v);
};

export const isTermsDocument = (v: any): v is TermsDocument => {
  return (
    typeof v === "object" &&
    v != null &&
    "title" in v &&
    typeof v.title === "string" &&
    "url" in v &&
    typeof v.url === "string" &&
    "description" in v &&
    typeof v.description === "string"
  );
};

export const isAccountNotFound = (v: any): v is AccountNotFound => {
  return typeof v === "object" && v != null && "email" in v && isEmail(v.email);
};

export const isInvalidEmail = (v: any): v is InvalidEmail => {
  return (
    typeof v === "object" &&
    v != null &&
    "email" in v &&
    typeof v.email === "string"
  );
};

export const isLoginRequired = (v: any): v is LoginRequired => {
  return typeof v === "object" && v != null;
};

export const isPasswordIncorrect = (v: any): v is PasswordIncorrect => {
  return typeof v === "object" && v != null && "email" in v && isEmail(v.email);
};

export const isPasswordRequired = (v: any): v is PasswordRequired => {
  return typeof v === "object" && v != null && "email" in v && isEmail(v.email);
};

export const isTermsNotAccepted = (v: any): v is TermsNotAccepted => {
  return (
    typeof v === "object" &&
    v != null &&
    "email" in v &&
    isEmail(v.email) &&
    "version" in v &&
    typeof v.version === "number" &&
    "documents" in v &&
    Array.isArray(v.documents) &&
    v.documents.every((i: any) => isTermsDocument(i))
  );
};

export const isLoginChallenge = (v: any): v is LoginChallenge => {
  return (
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "AccountNotFound" &&
      isAccountNotFound(v)) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "InvalidEmail" &&
      isInvalidEmail(v)) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "LoginRequired" &&
      isLoginRequired(v)) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "PasswordIncorrect" &&
      isPasswordIncorrect(v)) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "PasswordRequired" &&
      isPasswordRequired(v)) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "TermsNotAccepted" &&
      isTermsNotAccepted(v))
  );
};

export const isLoginRequest = (v: any): v is LoginRequest => {
  return (
    typeof v === "object" &&
    v != null &&
    "email" in v &&
    typeof v.email === "string" &&
    (!("password" in v) ||
      isUnencryptedPassword(v.password) ||
      v.password === null) &&
    (!("loginAs" in v) || isEmail(v.loginAs) || v.loginAs === null) &&
    (!("acceptTerms" in v) ||
      typeof v.acceptTerms === "boolean" ||
      v.acceptTerms === null)
  );
};

export const isLoginResponse =
  <R>(isR: (r: any) => r is R) =>
  (v: any): v is LoginResponse<R> => {
    return (
      (typeof v === "object" &&
        v != null &&
        "type" in v &&
        v.type === "Credentials" &&
        isCredentials((a0: any): a0 is R => isR(a0))(v)) ||
      isLoginChallenge(v)
    );
  };

export const isLoginResponseV1 = (v: any): v is LoginResponseV1 => {
  return isLoginResponse((a0: any): a0 is RoleV1 => isRoleV1(a0))(v);
};

export const isLoginResponseV2 = (v: any): v is LoginResponseV2 => {
  return isLoginResponse((a0: any): a0 is RoleV2 => isRoleV2(a0))(v);
};

export const isResetPasswordToken = (v: any): v is ResetPasswordToken => {
  return isTagged(
    (a0: any): a0 is "ResetPasswordToken" => a0 === "ResetPasswordToken"
  )(v);
};

export const isForgotPasswordRequest = (v: any): v is ForgotPasswordRequest => {
  return typeof v === "object" && v != null && "email" in v && isEmail(v.email);
};

export const isResetPasswordRequest = (v: any): v is ResetPasswordRequest => {
  return (
    typeof v === "object" &&
    v != null &&
    "token" in v &&
    isResetPasswordToken(v.token) &&
    "password" in v &&
    isUnencryptedPassword(v.password)
  );
};

export const isCheckResetPasswordTokenResult = (
  v: any
): v is CheckResetPasswordTokenResult => {
  return v === "expired" || v === "invalid" || v === "valid";
};

export const isCheckResetPasswordTokenResponse = (
  v: any
): v is CheckResetPasswordTokenResponse => {
  return (
    typeof v === "object" &&
    v != null &&
    "token" in v &&
    isResetPasswordToken(v.token) &&
    "result" in v &&
    isCheckResetPasswordTokenResult(v.result)
  );
};

/* eslint-enable @typescript-eslint/explicit-module-boundary-types */
/* eslint-enable @typescript-eslint/no-use-before-define */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable @typescript-eslint/no-empty-interface */
